import React, { useState, useEffect } from "react";
import { Form, Col, Button } from "react-bootstrap";
import { VIEW_SETTING_URL } from "../../../../Constant/api";
import { authService } from "../../../../Service/Axios";
import { convertTextToLink } from "../../../../Utils";

const SectnTitle = ({
  status,
  setsettings,
  eleavailable,
  fieldDescription,
  viewForm,
  setviewSetting,
  settings,
  seteleavailable,
  allElements,
  formId,
  setfirst,
  first,
  setviewForm,
  dynaDDselarr,
}) => {

  const [flagSect, setflagSect] = useState(null);

  useEffect(() => {
    if (!settings) setflagSect(null)
  }, [settings])

  const handleDelete = (ID) => {
    seteleavailable(allElements.filter((item) => item.questionId != ID));
  };

  const handleSetting = () => {
    viewSettingAction();
  };

  const viewSettingAction = async () => {
    const payload = {
      formId: formId,
      questionId: viewForm,
      elementType: first,
      sequenceNo: dynaDDselarr,
    };
    const response = await authService(VIEW_SETTING_URL, "POST", payload);
    if (response) {
      setviewSetting(response);
    }
    setsettings(!settings);
  };

  return (
    <Col xxl={12}
      xl={12}
      lg={12} md={12} sm={12} xs={12} className="mt-2 mb-2">
      <div
        className={`${(status == `preview` ||
          status == `In Progress` ||
          status == `Submitted` ||
          status == "Published") && !viewForm[0]?.internal
          ? `builder-row border rounded-2 bg-light preview-field`
          : (status == `preview` ||
            status == `In Progress` ||
            status == `Submitted` ||
            status == "Published") && viewForm[0]?.internal ?
            `builder-row border rounded-2 bg-light preview-field d-none`
            : flagSect == viewForm ? `builder-row border rounded-2 bg-light active` : `builder-row border rounded-2 bg-light`
          }`}
      >
        <div className="builder-row-header py-2 px-3 border-bottom d-flex">
          <h4>
            <span className="material-symbols-outlined align-middle me-2 pluto-section"></span>{" "}
            Section
          </h4>
          <div className="button-list ms-auto d-flex">
            <Button variant="transparent">
              <span
                className="material-symbols-outlined align-middle copy-btn me-2"
                onClick={(e) => { setflagSect(viewForm); handleSetting(); }}
              >
                settings
              </span>
            </Button>
            <Button variant="transparent">
              <span
                className="material-symbols-outlined align-middle remove-btn"
                onClick={(e) => handleDelete(viewForm)}
              >
                delete
              </span>
            </Button>
          </div>
        </div>
        <div className="builder-row-body d-flex flex-wrap">
          <div className="drag-btn d-flex justify-content-center align-items-center border-end">
            <Button variant="transparent">
              <span className="material-symbols-outlined">drag_indicator</span>
            </Button>
          </div>
          <div className="builder-field p-3">
            <Form.Group className="mb-3" controlId="shorttext">
              <Form.Label>
                {eleavailable.length > 0 ? eleavailable : "Add section header"}
              </Form.Label>
              <div
                className="d-block mb-3"
                dangerouslySetInnerHTML={{
                  __html:
                    fieldDescription && fieldDescription.length > 0
                      ? convertTextToLink(fieldDescription)
                      : "",
                }}
              />
            </Form.Group>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default SectnTitle;
